import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import './SwiperThumb.css';

const images = [
  "https://swiperjs.com/demos/images/nature-1.jpg",
  "https://swiperjs.com/demos/images/nature-2.jpg",
  "https://swiperjs.com/demos/images/nature-3.jpg",
  "https://swiperjs.com/demos/images/nature-4.jpg",
  "https://swiperjs.com/demos/images/nature-5.jpg",
  "https://swiperjs.com/demos/images/nature-6.jpg",
  "https://swiperjs.com/demos/images/nature-7.jpg",
  "https://swiperjs.com/demos/images/nature-8.jpg",
  "https://swiperjs.com/demos/images/nature-9.jpg",
  "https://swiperjs.com/demos/images/nature-10.jpg",
];

const SwiperThumb = (props) => {


  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null); // State for full-screen image
  const closeModal = () => setSelectedImage(null); // Close modal function

  return (
    <div className="swiper-container">
      {/* Main Swiper */}
      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "--swiper-pagination-color": "#fff",
        }}
        loop={true}
        spaceBetween={10}
        navigation
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="main-swiper"
      >
        {props?.roomImgs?.map((image, index) => {
          return (
            <SwiperSlide
              key={index}
              style={{ height: props.height ? props.height : "273px" }}
            >
              <img
                className="img-fluid"
                style={{ objectFit: props.objectFit ? "contain" : "cover" }}
                src={image}
                alt={`Slide ${index + 1}`}
                onClick={() => setSelectedImage(image)}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* Thumbnails Swiper */}
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={5}
        slidesPerView={props.value ? props.value : 3}
        freeMode
        watchSlidesProgress
        modules={[FreeMode, Navigation, Thumbs]}
        className="thumbs-swiper"
      >
        {props?.roomImgs?.map((image, index) => {
          return (
            <SwiperSlide key={index} style={{height: '88px'}}>
              <img src={image} alt={`Thumbnail ${index + 1}`} />
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* Full-Screen Modal */}
      {selectedImage && (
        <div className="modal" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}>
          {/* Close Button */}
          <button onClick={closeModal} style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: 'transparent',
            border: 'none',
            color: '#000',
            fontSize: '40px',
            borderRadius:"4px",
            background: '#fff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '50px',
            height: '50px',
            cursor: 'pointer',
          }}>
            &times;
          </button>
          <img
            src={selectedImage}
            alt="Full Screen"
            style={{ maxHeight: '90%', maxWidth: '90%', width:"70%" }}
          />
        </div>
      )}
    </div>
  );
};

export default SwiperThumb;
